document.addEventListener('DOMContentLoaded', () => {
  const currentUrl = encodeURIComponent(window.location.href);
  const socialLinksContainer = document.querySelector('.wp-block-lb-post-author-share');
  if (!socialLinksContainer) return;

  socialLinksContainer.querySelectorAll('.js-copy-link').forEach((link) => {
    link.dataset.copy = decodeURIComponent(currentUrl);
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const textToCopy = this.getAttribute('data-copy');

      function showCopiedTooltip(el) {
        const tooltip = document.createElement('div');
        tooltip.textContent = 'Link kopiert';

        tooltip.style.position = 'absolute';
        tooltip.style.background = '#fd6220';
        tooltip.style.color = '#fff';
        tooltip.style.padding = '10px 15px';
        tooltip.style.borderRadius = '4px';
        tooltip.style.fontSize = '14px';
        tooltip.style.pointerEvents = 'none';
        tooltip.style.transition = 'opacity 0.3s ease';
        tooltip.style.opacity = '1';
        tooltip.style.zIndex = '9999';

        const rect = el.getBoundingClientRect();
        tooltip.style.top = `${rect.top - 50 + window.scrollY}px`;
        tooltip.style.left = `${rect.left + rect.width / 2 + window.scrollX}px`;
        tooltip.style.transform = 'translateX(-50%)';

        document.body.appendChild(tooltip);

        setTimeout(() => {
          tooltip.style.opacity = '0';
          setTimeout(() => tooltip.remove(), 300);
        }, 2000);
      }

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(textToCopy)
          .then(() => showCopiedTooltip(this))
          .catch((err) => console.error('Copy failed:', err));
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        showCopiedTooltip(this);
      }
    });
  });
});
